var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.811 12.206a.228.228 0 00-.123-.064l-4.333-.722-5.792-2.896-.006-.002a.23.23 0 00-.033-.012c-.005-.002-.009-.004-.013-.004a.244.244 0 00-.05-.006H2.728a.227.227 0 00-.228.228v5.822c0 .108.076.202.183.223l2.13.426a1.681 1.681 0 002.937.306h9.605a1.682 1.682 0 002.768 0h.799c.035 0 .07-.008.102-.024l1.455-.728a.228.228 0 00.126-.204v-1.455a.227.227 0 00-.067-.16l-.727-.728zm-10.123-3.11l4.632 2.315h-4.632V9.095zm-5.321 6.682a1.23 1.23 0 01-1.229-1.228 1.23 1.23 0 011.229-1.229 1.23 1.23 0 010 2.456zm12.372 0a1.23 1.23 0 010-2.457 1.23 1.23 0 011.229 1.229 1.23 1.23 0 01-1.229 1.228z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default Svg1;